<script setup lang="ts">
import { computed } from "vue";

import { colorsByTheme, DART_ICON_GRADIENT_BY_THEME } from "~/constants/style";
import Dart from "~/icons/Dart.vue";
import { usePageStore } from "~/stores";

const pageStore = usePageStore();

const show = computed(() => pageStore.redirectedToNative);

const continueInBrowser = () => {
  pageStore.redirectedToNative = false;
};

const downloadDesktopApp = () => {
  pageStore.redirectedToNative = false;
  window.open("/redirect/desktop-app", "_blank");
};

const colors = computed(() => colorsByTheme[pageStore.theme]);
const iconBg = computed(() => DART_ICON_GRADIENT_BY_THEME[pageStore.theme]);
</script>

<template>
  <Teleport to="body">
    <div
      v-if="show"
      class="fixed inset-0 z-[10030] flex flex-col items-center justify-evenly"
      :style="{ background: colors.bgStd }">
      <div class="flex flex-col items-center gap-6 px-4 text-center select-none">
        <div
          class="dart-icon-grad-bg flex size-20 shrink-0 items-center justify-center rounded-2xl border border-md p-4">
          <Dart class="icon-xl" />
        </div>
        <div class="flex flex-col items-center gap-2">
          <span class="text-2xl font-semibold text-md">Opening in the Dart app</span>
          <div class="flex flex-col items-center gap-0.5 text-base text-vlt">
            <template v-if="pageStore.isDesktop">
              <span>
                Don't have the app?
                <button
                  type="button"
                  class="text-primary-base hover:text-primary-hover-light dark:hover:text-primary-hover-dark"
                  @click="downloadDesktopApp">
                  Download the {{ pageStore.isMac ? "Mac" : pageStore.isLinux ? "Linux" : "Windows" }} app
                </button>
              </span>
              <span>
                or
                <button type="button" class="underline hover:text-lt" @click="continueInBrowser">
                  continue in browser
                </button>
              </span>
            </template>
            <button v-else type="button" class="underline hover:text-lt" @click="continueInBrowser">
              Continue in browser
            </button>
          </div>
        </div>
      </div>
      <div />
    </div>
  </Teleport>
</template>

<style scoped>
.dart-icon-grad-bg {
  background: v-bind(iconBg);
}
</style>
